export function getHumanReadableAccountById (){
  return ( invoiceAccount ) => `${invoiceAccount.account_id} - ${invoiceAccount.line_one}`;
}


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/getHumanReadableAccountById.filter.js
 **/